import {
  CIRCLE_SHAPE_TYPE,
  RECT_SHAPE_TYPE,
  TRIANGLE_SHAPE_TYPE,
} from "../../Designer/constants.ts";
import type { ShapeType } from "../../Designer/types.ts";

export const SHAPE_TYPE_DISPLAY_NAMES: Record<ShapeType, string> = {
  [RECT_SHAPE_TYPE]: "Rectangle",
  [CIRCLE_SHAPE_TYPE]: "Circle",
  [TRIANGLE_SHAPE_TYPE]: "Triangle",
};
